import { PrebuiltPage } from "./web-report/index"
import { Helmet } from "react-helmet"
import { useState } from "react"

const App = () => {
  const [report, setReport] = useState(null)

  import(`../../../tmp/${process.env.REACT_APP_REPORT_FILENAME}.json`).then(module => {
    setReport(module.default)
  })

  if (!report) {
    return null
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{report.reportContent.setup.projectName} - Report</title>
      </Helmet>
      <PrebuiltPage report={report} loading={false} />
    </>
  )
}

export default App
